import { convertDateArrayFromDate, convertDateFromDateArray, } from '@starjack/utils';
import { parse } from 'date-fns';
import { Environment } from '../../environment';
export const PC_DEFAULT_DATE_START = parse('2000-01-01', 'yyyy-MM-dd', new Date());
export const PC_DEFAULT_DATE_END = parse('2100-01-01', 'yyyy-MM-dd', new Date());
export const allEnvironments = [
    Environment.PORTAL,
    Environment.INTEGRATION,
    Environment.B2B,
    Environment.HOSPITALITY,
];
export var ProductType;
(function (ProductType) {
    ProductType["SEASON"] = "SEASON";
    ProductType["DAY"] = "DAY";
})(ProductType || (ProductType = {}));
export const mapProductConfigurationToFrontend = (bPc) => {
    return {
        ...bPc,
        startDateLabel: convertDateFromDateArray(bPc.startDateLabel),
        pickupInfoTextDE: bPc.pickupInfoText?.de,
        pickupInfoTextEN: bPc.pickupInfoText?.en,
        barcodeInfoTextDE: bPc.barcodeInfoText?.de,
        barcodeInfoTextEN: bPc.barcodeInfoText?.en,
        infoTextDE: bPc.infoText?.de,
        infoTextEN: bPc.infoText?.en,
        filterTagsDE: bPc.filterTags?.de,
        filterTagsEN: bPc.filterTags?.en,
        validityRange: {
            from: convertDateFromDateArray(bPc.validityRange.from),
            to: convertDateFromDateArray(bPc.validityRange.to),
        },
        startDateValidityRange: {
            from: convertDateFromDateArray(bPc.startDateValidityRange.from),
            to: convertDateFromDateArray(bPc.startDateValidityRange.to),
        },
        endDate: convertDateFromDateArray(bPc.endDate),
    };
};
export const mapProductConfigurationToBackend = (p) => {
    // PC_DEFAULT_DATE_START
    // PC_DEFAULT_DATE_END
    const configuration = {
        ...p,
        infoText: {
            de: p.infoTextDE,
            en: p.infoTextEN,
        },
        filterTags: {
            de: p.filterTagsDE,
            en: p.filterTagsEN,
        },
        pickupInfoText: {
            de: p.pickupInfoTextDE,
            en: p.pickupInfoTextEN,
        },
        barcodeInfoText: {
            de: p.barcodeInfoTextDE,
            en: p.barcodeInfoTextEN,
        },
        productTypeOverride: p.productTypeOverride || null,
        validityRange: {
            from: convertDateArrayFromDate(p.validityRange.from),
            to: convertDateArrayFromDate(p.validityRange.to),
        },
        startDateValidityRange: {
            from: convertDateArrayFromDate(p.startDateValidityRange.from || PC_DEFAULT_DATE_START),
            to: convertDateArrayFromDate(p.startDateValidityRange.to || PC_DEFAULT_DATE_END),
        },
        endDate: p.endDate ? convertDateArrayFromDate(p.endDate) : undefined,
        startDateLabel: p.startDateLabel
            ? convertDateArrayFromDate(p.startDateLabel)
            : undefined,
    };
    // TODO: refactor proper typing
    delete configuration.infoTextDE;
    delete configuration.infoTextEN;
    delete configuration.filterTagsDE;
    delete configuration.filterTagsEN;
    delete configuration.pickupInfoTextDE;
    delete configuration.pickupInfoTextDE;
    delete configuration.barcodeInfoTextDE;
    delete configuration.barcodeInfoTextEN;
    return configuration;
};
export const mapProductToFrontend = (product) => {
    return {
        ...product,
        persons: product.persons.map((person) => ({
            ...person,
            birthday: {
                from: convertDateFromDateArray(person.birthday.from),
                to: convertDateFromDateArray(person.birthday.to),
            },
            prices: person.prices.map((price) => ({
                ...price,
                validity: {
                    from: convertDateFromDateArray(price.validity.from),
                    to: convertDateFromDateArray(price.validity.to),
                },
            })),
        })),
    };
};
export const mapPackageTicketToFrontend = (ticket) => {
    const validity = {
        from: convertDateFromDateArray(ticket.validity.from),
        to: convertDateFromDateArray(ticket.validity.to),
    };
    return {
        ...ticket,
        persons: ticket.persons.map((person) => ({
            name: person.name,
            birthday: person.birthday
                ? {
                    from: convertDateFromDateArray(person.birthday.from),
                    to: convertDateFromDateArray(person.birthday.to),
                }
                : null,
            prices: [
                {
                    id: ticket.productId,
                    validity,
                    price: ticket.price,
                    extra: person.extra,
                },
            ],
        })),
    };
};
